export const levelInfos = [
    { id_level: 1, name: "msgAboutLevel1Title", text: "msgAboutLevel1Text" },
    { id_level: 2, name: "msgAboutLevel2Title", text: "msgAboutLevel2Text" },
    { id_level: 3, name: "msgAboutLevel3Title", text: "msgAboutLevel3Text" },
    { id_level: 4, name: "msgAboutLevel4Title", text: "msgAboutLevel4Text" },
    { id_level: 5, name: "msgAboutLevel5Title", text: "msgAboutLevel5Text" },
]

export const passwordDefault = {
    password: "", repassword: ""
}
export const userDefault = {
    firstname: "",
    lastname: "",
    username: "",
    country: "",
    size: "",
    types: "",
    email: "",
    password: "",
    repassword: ""
}

export const companySizes = [
    "msgCompanySize1",
    "msgCompanySize2",
    "msgCompanySize3",
    "msgCompanySize4",
]

export const productTypes = [
    "msgProductType1",
    "msgProductType2",
    "msgProductType3",
    "msgProductType4",
    "msgProductType5",
    "msgProductType6",
    "msgProductType7",
    "msgProductType8",
    "msgProductType9",
    "msgProductType10",
    "msgProductType11",
    "msgProductType12",
    "msgProductType13",
    "msgProductType14",
    "msgProductType15",
    "msgProductType16",
    "msgProductType17",
    "msgProductType18",
    "msgProductType19",
    "msgProductType20",
    "msgProductType21",
    "msgProductType22",
    "msgProductType23",
    "msgProductType24",
    "msgProductType25",
    "msgProductType26",
    "msgProductType27",
]

export const countries = [
    "msgAfghanistan",
    "msgAlbania",
    "msgAlgeria",
    "msgAmericanSamoa",
    "msgAndorra",
    "msgAngola",
    "msgAnguilla",
    "msgAntarctica",
    "msgAntiguaandBarbuda",
    "msgArgentina",
    "msgArmenia",
    "msgAruba",
    "msgAustralia",
    "msgAustria",
    "msgAzerbaijan",
    "msgBahamas",
    "msgBahrain",
    "msgBangladesh",
    "msgBarbados",
    "msgBelarus",
    "msgBelgium",
    "msgBelize",
    "msgBenin",
    "msgBermuda",
    "msgBhutan",
    "msgBolivia",
    "msgBosniaHerzegovina",
    "msgBotswana",
    "msgBouvetIsland",
    "msgBrazil",
    "msgBritishIndian",
    "msgBrunei",
    "msgBulgaria",
    "msgBurkinaFaso",
    "msgBurundi",
    "msgCambodia",
    "msgCameroon",
    "msgCanada",
    "msgCapeVerde",
    "msgCaymanIslands",
    "msgCentralAfrican",
    "msgChad",
    "msgChile",
    "msgChina",
    "msgChristmasIsland",
    "msgCocosIslands",
    "msgColombia",
    "msgComoros",
    "msgCongo",
    "msgRepublicCongo",
    "msgCookIslands",
    "msgCostaRica",
    "msgIvoryCoast",
    "msgCroatia",
    "msgCuba",
    "msgCyprus",
    "msgCzechRepublic",
    "msgDenmark",
    "msgDjibouti",
    "msgDominica",
    "msgDominicanRepublic",
    "msgEastTimor",
    "msgEcuador",
    "msgEgypt",
    "msgEngland",
    "msgElSalvador",
    "msgEquatorialGuinea",
    "msgEritrea",
    "msgEstonia",
    "msgEthiopia",
    "msgFalklandIslands",
    "msgFaroeIslands",
    "msgFijiIslands",
    "msgFinland",
    "msgFrance",
    "msgFrenchGuiana",
    "msgFrenchPolynesia",
    "msgFrenchSouthern",
    "msgGabon",
    "msgGambia",
    "msgGeorgia",
    "msgGermany",
    "msgGhana",
    "msgGibraltar",
    "msgGreece",
    "msgGreenland",
    "msgGrenada",
    "msgGuadeloupe",
    "msgGuam",
    "msgGuatemala",
    "msgGuernsey",
    "msgGuinea",
    "msgGuineaBissau",
    "msgGuyana",
    "msgHaiti",
    "msgHeardMcDonald",
    "msgHolySee",
    "msgHonduras",
    "msgHongKong",
    "msgHungary",
    "msgIceland",
    "msgIndia",
    "msgIndonesia",
    "msgIran",
    "msgIraq",
    "msgIreland",
    "msgIsrael",
    "msgIsleMan",
    "msgItaly",
    "msgJamaica",
    "msgJapan",
    "msgJersey",
    "msgJordan",
    "msgKazakhstan",
    "msgKenya",
    "msgKiribati",
    "msgKuwait",
    "msgKyrgyzstan",
    "msgLaos",
    "msgLatvia",
    "msgLebanon",
    "msgLesotho",
    "msgLiberia",
    "msgLibyanJamahiriya",
    "msgLiechtenstein",
    "msgLithuania",
    "msgLuxembourg",
    "msgMacao",
    "msgNorthMacedonia",
    "msgMadagascar",
    "msgMalawi",
    "msgMalaysia",
    "msgMaldives",
    "msgMali",
    "msgMalta",
    "msgMarshallIslands",
    "msgMartinique",
    "msgMauritania",
    "msgMauritius",
    "msgMayotte",
    "msgMexico",
    "msgMicronesia",
    "msgMoldova",
    "msgMonaco",
    "msgMongolia",
    "msgMontserrat",
    "msgMontenegro",
    "msgMorocco",
    "msgMozambique",
    "msgMyanmar",
    "msgNamibia",
    "msgNauru",
    "msgNepal",
    "msgNetherlands",
    "msgNetherlandsAntilles",
    "msgNewCaledonia",
    "msgNewZealand",
    "msgNicaragua",
    "msgNiger",
    "msgNigeria",
    "msgNiue",
    "msgNorfolkIsland",
    "msgNorthKorea",
    "msgNorthernIreland",
    "msgNorthernMariana",
    "msgNorway",
    "msgOman",
    "msgPakistan",
    "msgPalau",
    "msgPalestine",
    "msgPanama",
    "msgPapua",
    "msgParaguay",
    "msgPeru",
    "msgPhilippines",
    "msgPitcairn",
    "msgPoland",
    "msgPortugal",
    "msgPuertoRico",
    "msgQatar",
    "msgReunion",
    "msgRomania",
    "msgRussianFederation",
    "msgRwanda",
    "msgSaintHelena",
    "msgSaintKitts",
    "msgSaintLucia",
    "msgSaintPierre",
    "msgSaintVincent",
    "msgSamoa",
    "msgSanMarino",
    "msgSaoTome",
    "msgSaudiArabia",
    "msgScotland",
    "msgSenegal",
    "msgSerbia",
    "msgSeychelles",
    "msgSierraLeone",
    "msgSingapore",
    "msgSlovakia",
    "msgSlovenia",
    "msgSolomonIslands",
    "msgSomalia",
    "msgSouthAfrica",
    "msgSouthSandwich",
    "msgSouthKorea",
    "msgSouthSudan",
    "msgSpain",
    "msgSriLanka",
    "msgSudan",
    "msgSuriname",
    "msgSvalbardJan",
    "msgSwaziland",
    "msgSweden",
    "msgSwitzerland",
    "msgSyria",
    "msgTajikistan",
    "msgTanzania",
    "msgThailand",
    "msgTimorLeste",
    "msgTogo",
    "msgTokelau",
    "msgTonga",
    "msgTrinidadTobago",
    "msgTunisia",
    "msgTurkey",
    "msgTurkmenistan",
    "msgTurksCaicos",
    "msgTuvalu",
    "msgUganda",
    "msgUkraine",
    "msgUnitedArabEmirates",
    "msgUnitedKingdom",
    "msgUnitedStates",
    "msgUnitedStatesMinor",
    "msgUruguay",
    "msgUzbekistan",
    "msgVanuatu",
    "msgVenezuela",
    "msgVietnam",
    "msgVirginIslandsBritish",
    "msgVirginIslandsUS",
    "msgWales",
    "msgWallisFutuna",
    "msgWesternSahara",
    "msgYemen",
    "msgZambia",
    "msgZimbabwe",
]